type timelinesType = {
    text:string
    date:string
    color:string
}

export const timelines : timelinesType[] = [
    {'text':'Attend College in Gunadarma University', 'date':'Sep 2020', 'color':'text-white'},
    {'text':'2nd Place -CommunityBased- Gunadarma Competition', 'date':'Jan 2022', 'color':'text-yellow-300'},
    {'text':'Joined Bangkit Academy : Machine Learning', 'date':'Feb 2023', 'color':'text-white'},
    {'text':'Achieved TensoFlow Developer Certificate', 'date':'Aug 2023', 'color':'text-green-400'},
    {'text':'Joined Data Academy : Data Engineering', 'date':'Aug 2023', 'color':'text-white'},
    {'text':'Joined Lintas Media Danawa : AI Engineer Intern', 'date':'Oct 2023', 'color':'text-blue-500'},
    {'text':'1st Place -TheBestTeam- Data Academy', 'date':'Dec 2023', 'color':'text-yellow-300'},
]